import {FC, useState, createContext, useContext} from 'react'
import {
    QueryState,
    QueryRequestContextProps,
    initialQueryRequest,
    WithChildren,
} from '../../../../../_metronic/helpers'

const DLMThresholdQueryRequestContext = createContext<QueryRequestContextProps>(initialQueryRequest)

const DLMThresholdQueryRequestProvider: FC<WithChildren> = ({children}) => {
    const [state, setState] = useState<QueryState>(initialQueryRequest.state)

    const updateState = (updates: Partial<QueryState>) => {
        const updatedState = {...state, ...updates} as QueryState
        setState(updatedState)
    } 

    return (
    <DLMThresholdQueryRequestContext.Provider value={{state, updateState}}>
        {children}
    </DLMThresholdQueryRequestContext.Provider>
    )
}

const useDLMThresholdQueryRequest = () => useContext(DLMThresholdQueryRequestContext)
export {DLMThresholdQueryRequestProvider, useDLMThresholdQueryRequest}
